<template>
	<div class="settings-block">
		<template v-for="(item, idx) in getSettings">
			<div class="w-100 h3 text-center" :key="`title-${idx}`">
				{{ item.text }}
			</div>
			<div class="w-100 text-center my-30 settings-block__choices" :key="`block-${idx}`">
				<c-button bg="52FF00"
				          color="000"
				          class="m-10"
				          tag="button"
				          :class="{ active: getQuery[item.name] &&
					          getQuery[item.name.toLowerCase()] === op.toLowerCase() }"
				          @click="setQuery(item.name, op)"
				          v-for="(op, i) in item.options"
				          :key="`btn-${i}`">
					{{ op }}
				</c-button>
			</div>
		</template>
		<div class="w-100 px-40 mt-20 text-center">
			<c-button bg="FFA800"
			          tag="button"
			          color="000"
			          @click="getData"
			          :disabled="!activeBtn"
			          class="w-100">
				Go
			</c-button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			settings: null,
			getQuery: {},
		};
	},
	computed: {
		...mapGetters(['getSettings', 'getScenarios']),
		activeBtn() {
			return this.getSettings.length === Object.keys(this.getQuery).length;
		},
	},
	mounted() {
		window.scrollTo(0, 0);
		if (!this.getSettings || !this.getSettings.length) this.$router.push({ name: 'DayView' });
	},
	methods: {
		setQuery(key, val) {
			this.$set(this.getQuery, key.toLowerCase(), val.toLowerCase());
		},
		getData() {
			this.$ga.event('Skaavok', 'Click on "GO" in settings');
			this.$router.push({ name: 'DayViewSingle', params: { id: this.$route.params.id }, query: this.getQuery });
		},
	},
	beforeDestroy() {
		this.$store.dispatch('clearSettings');
	},
};
</script>

<style lang="scss">
	.settings-block{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: auto 0;
		padding: 70px 20px 20px;
		min-height: 86vh;
		&__choices{
			.c-button{
				opacity: .5;
				&:hover,
				&.active{
					opacity: 1;
				}
			}
		}
		.c-button{
			font-family: 'Burbank Big Cd Bd', sans-serif;
			font-size: 36px;
			padding: 15px 20px 5px;
			line-height: 36px;
			max-width: 300px;
			margin: 0 auto;
			@include respond-to(max576){
				font-size: 24px;
				line-height: 24px;
				padding: 10px 15px 3px;
			}
		}
	}
</style>
